export const formatChars = {
  '9': '[0-9]',
  '5': '[0-5]',
  a: '[A-Za-z]',
  '*': '[A-Za-z0-9]',
};
